export function PlayLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="182"
      height="98"
      viewBox="0 0 182 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.373 25.026C49.373 28.6474 48.5 32.0424 46.754 35.211C45.0727 38.3797 42.389 40.934 38.703 42.874C35.0817 44.814 30.4903 45.784 24.929 45.784H13.58V71.78H7.39098e-06V4.07403H24.929C30.167 4.07403 34.629 4.97936 38.315 6.79003C42.001 8.60069 44.7493 11.0904 46.56 14.259C48.4353 17.4277 49.373 21.0167 49.373 25.026ZM24.347 34.823C28.0977 34.823 30.8783 33.9824 32.689 32.301C34.4997 30.555 35.405 28.13 35.405 25.026C35.405 18.43 31.719 15.132 24.347 15.132H13.58V34.823H24.347ZM64.8347 2.83718e-05V71.78H51.2547V2.83718e-05H64.8347ZM66.9997 44.717C66.9997 39.285 68.0667 34.4674 70.2007 30.264C72.3994 26.0607 75.3417 22.8274 79.0277 20.564C82.7784 18.3007 86.9494 17.169 91.5407 17.169C95.5501 17.169 99.0421 17.9774 102.017 19.594C105.056 21.2107 107.481 23.2477 109.292 25.705V18.042H122.969V71.78H109.292V63.923C107.546 66.445 105.121 68.5467 102.017 70.228C98.9774 71.8447 95.4531 72.653 91.4437 72.653C86.9171 72.653 82.7784 71.489 79.0277 69.161C75.3417 66.833 72.3994 63.5674 70.2007 59.364C68.0667 55.096 66.9997 50.2137 66.9997 44.717ZM109.292 44.911C109.292 41.613 108.645 38.8 107.352 36.472C106.058 34.0794 104.312 32.2687 102.114 31.04C99.9151 29.7467 97.5547 29.1 95.0327 29.1C92.5107 29.1 90.1827 29.7144 88.0487 30.943C85.9147 32.1717 84.1687 33.9824 82.8107 36.375C81.5174 38.703 80.8707 41.4837 80.8707 44.717C80.8707 47.9504 81.5174 50.7957 82.8107 53.253C84.1687 55.6457 85.9147 57.4887 88.0487 58.782C90.2474 60.0754 92.5754 60.722 95.0327 60.722C97.5547 60.722 99.9151 60.1077 102.114 58.879C104.312 57.5857 106.058 55.775 107.352 53.447C108.645 51.0544 109.292 48.209 109.292 44.911ZM181.822 18.042L148.551 97.194H134.098L145.738 70.422L124.204 18.042H139.433L153.304 55.581L167.369 18.042H181.822Z"
        fill="url(#paint0_linear_5080_3458)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5080_3458"
          x1="0.491876"
          y1="4.18004"
          x2="181.797"
          y2="69.1375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6200" />
          <stop offset="1" stopColor="#FF9350" />
        </linearGradient>
      </defs>
    </svg>
  );
}
